import { FC } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField as MuiTextField } from '@mui/material'
import { useTranslate } from 'react-admin'
import { xxllncColor } from '../layout/theme/color'

interface SearchFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  sx?: Record<string, unknown>
}

export const SearchField: FC<SearchFieldProps> = ({ value, onChange, placeholder, sx }) => {
  const translate = useTranslate()

  return (
    <MuiTextField
      size="small"
      placeholder={placeholder ?? translate('data.searchTools')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 18, color: 'rgba(0,0,0,0.25)' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        'ml': 'auto', 'maxWidth': 360,
        '& .MuiOutlinedInput-root': {
          'borderRadius': '10px', 'fontSize': 13,
          '& fieldset': { borderColor: 'rgba(0,0,0,0.08)' },
          '&:hover fieldset': { borderColor: 'rgba(0,0,0,0.15)' },
          '&.Mui-focused fieldset': { borderColor: xxllncColor.opDark40, borderWidth: 1 },
        },
        ...sx,
      }}
    />
  )
}
